import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-[100dvh] overflow-x-hidden bg-white dark:bg-[#0a0e27]">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
